import React, { useState, useEffect } from 'react';

const ArticleCardSkeleton = () => {
  const [color1, setColor1] = useState('gray');
  const [color2, setColor2] = useState('gray');
  const [color3, setColor3] = useState('gray');

  useEffect(() => {
    const animateColor = (setColor) => {
      let direction = 1;
      let colorValue = 0;
      const interval = setInterval(() => {
        colorValue += direction * 0.01;
        if (colorValue >= 1 || colorValue <= 0) direction *= -1;
        setColor(
          `rgba(${Math.round(192 + 63 * colorValue)}, ${Math.round(
            192 + 63 * colorValue
          )}, ${Math.round(192 + 63 * colorValue)})`
        );
      }, 10);
      return () => clearInterval(interval);
    };

    const stopColor1 = animateColor(setColor1);
    const stopColor2 = animateColor(setColor2);
    const stopColor3 = animateColor(setColor3);

    return () => {
      stopColor1();
      stopColor2();
      stopColor3();
    };
  }, []);

  return (
    <div className="border border-[#34345c] bg-[#d6daf0] rounded-md overflow-hidden min-w-[80%]">
      <div className="bg-[#eef2ff] border-b border-[#34345c] flex justify-center">
        <img src="/assets/loading.gif" alt="loading" className="w-[50%] h-[auto] p-10" />
      </div>

      <div className="p-3 flex flex-col gap-1">
        <div
          className="mockupText"
          style={{ backgroundColor: color1, width: '90%' }}
        />
        <div
          className="mockupText"
          style={{ backgroundColor: color2, width: '60%' }}
        />
        <div
          className="mockupText"
          style={{ backgroundColor: color3, width: '75%' }}
        />
      </div>
    </div>
  );
};

export default ArticleCardSkeleton;
